var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"text-align":"center","padding":"40px"}},[_c('p',[_vm._v("正在处理...")])])
}]

export { render, staticRenderFns }